import { Stack as MuiStack, StackProps, SxProps, Theme } from "@mui/material"
interface StackPropsType extends StackProps {
  variant?: "rowCenter" | "columnCenter" | "rowCenterSpaceBetween" | undefined
  children: ReactNode
  background?: "whiteShadow" | undefined
  sx?: SxProps<Theme>
}
const style = {
  background: (theme: Theme) => theme.palette.background.default,
  borderRadius: "5px",
  boxShadow: (theme: Theme) => theme.shadows[11]
}
const Stack = ({ variant, children, sx, background, ...rest }: StackPropsType) => {
  let styles: SxProps<Theme> = { ...sx }
  if (background === "whiteShadow") styles = { ...styles, ...style }

  if (variant === "rowCenter")
    return (
      <MuiStack direction={"row"} justifyContent={"center"} alignItems={"center"} sx={{ ...styles }} {...rest}>
        {children}
      </MuiStack>
    )
  else if (variant === "columnCenter")
    return (
      <MuiStack direction={"column"} justifyContent={"center"} alignItems={"center"} sx={{ ...styles }} {...rest}>
        {children}
      </MuiStack>
    )
  else if (variant === "rowCenterSpaceBetween") {
    return (
      <MuiStack direction={"row"} justifyContent={"space-between"} alignItems={"center"} sx={{ ...styles }} {...rest}>
        {children}
      </MuiStack>
    )
  }
  return (
    <MuiStack sx={{ ...styles }} {...rest}>
      {children}
    </MuiStack>
  )
}

export default Stack
